import moment from "moment";

export default function getCalendarWeekDates(calendarWeek: any) {
  const dates = [];
  for (let i = 0; i < 7; i += 1) {
    const date = moment()
      .isoWeekYear(calendarWeek.year)
      .isoWeek(calendarWeek.week)
      .isoWeekday(i + 1);

    dates.push(date);
  }

  return dates;
}
